export const AUTH_SUCCESS = "passwordReset/AUTH_SUCCESS";
export const CHANGE_FORM = "passwordReset/CHANGE_FORM";
export const SET_ERRORS = "passwordReset/SET_ERRORS";
export const INIT = "passwordReset/INIT";
export const OPEN_DIALOG = "passwordReset/OPEN_DIALOG";

export const authSuccess = () => ({
  type: AUTH_SUCCESS
});

export const changeForm = (key, value) => ({
  type: CHANGE_FORM,
  key,
  value
});

export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

export const init = () => ({
  type: INIT
});

export const openDialog = () => ({
  type: OPEN_DIALOG
});

const initialState = {
  isAuthed: false,
  password: "",
  passwordConfirmation: "",
  errors: [],
  isDialogOpen: false
};

const passwordReset = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_SUCCESS: {
      return { ...state, isAuthed: true };
    }
    case CHANGE_FORM: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case SET_ERRORS: {
      return { ...state, errors: action.errors };
    }
    case INIT: {
      return { ...state, password: "", passwordConfirmation: "", errors: [] };
    }
    case OPEN_DIALOG: {
      return { ...state, isDialogOpen: true };
    }
    default:
      return state;
  }
};

export default passwordReset;



// WEBPACK FOOTER //
// ./src/redux/modules/passwordReset.js